import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserConfigService } from './user-config.service';

export class AddressBookSearchResult {
  constructor(public id: number,
              public lastname: string,
              public firstname: string,
              public company: string,
              public street: string,
              public city: string,
              public zipcode: string,
              public phone: string,
              public mobile: string,
              public fax: string,
              public email: string,
              public comment: string) {
  }
}

@Injectable({
  providedIn: 'root'
})
export class AddressbookService {

  searchingaddress = false;

  constructor(private http: HttpClient, private userConfig: UserConfigService) { }

  search(searchstring): Observable<AddressBookSearchResult[]>
  {
    this.searchingaddress = true;
    return this.http.post<any>('/api/v1/user/' + this.userConfig.userid  + '/addressbook/search', {
            request: {
                query: searchstring
            }
        })
        .pipe(map(result => {
            const addresses = [];
            if (result.success === true)
            {
                for (const address of result.addresses)
                {
                  addresses.push(new AddressBookSearchResult(
                    address.ID,
                    address.properties.lastname,
                    address.properties.firstname,
                    address.properties.company,
                    address.properties.street,
                    address.properties.city,
                    address.properties.zipcode,
                    address.properties.phone,
                    address.properties.mobile,
                    address.properties.fax,
                    address.properties.email,
                    address.properties.comment
                  ));
                }
            }
            this.searchingaddress = false;
            return addresses;
        }));
  }
}
